/**
 * IPv4 校验。单独文件，避免 config.js ↔ util.js 循环依赖（config 需用 isIP，util 又 import config）。
 */
export function isIP(ip) {
  const reg = /^(\d+)\.(\d+)\.(\d+)\.(\d+)$/;
  if (
    reg.test(ip) &&
    RegExp.$1 < 256 &&
    RegExp.$2 < 256 &&
    RegExp.$3 < 256 &&
    RegExp.$4 < 256
  ) {
    return true;
  }
  return false;
}
